class A11yFocus extends HTMLElement {
  connectedCallback() {
    this.tabOutTarget = this.dataset.tabOutTarget || null;
    this.activeElementSelector = this.dataset.activeElementSelector || null;

    this.addEventListener('focusin', (ev) => {
      if (this.activeElementSelector && this.querySelector(this.activeElementSelector)) {
        this.querySelector(this.activeElementSelector).focus();
      }
    });
    this.addEventListener('keydown', (ev) => {
      switch (ev.code) {
        case 'ArrowLeft':
          ev.stopPropagation();
          ev.preventDefault();
          this.moveFocusLeft();
          break;
        case 'ArrowRight':
          ev.stopPropagation();
          ev.preventDefault();
          this.moveFocusRight();
          break;
        case 'Home':
          ev.stopPropagation();
          ev.preventDefault();
          this.moveFocusStart();
          break;
        case 'END':
          ev.stopPropagation();
          ev.preventDefault();
          this.moveFocusEnd();
          break;
        case 'Tab':
          if (ev.shiftKey) {
            ev.stopPropagation();
            ev.preventDefault();
            this.moveFocusOutPrevious();
          } else {
            ev.stopPropagation();
            ev.preventDefault();
            this.moveFocusOutNext();
          }
          break;
      }
      return false;
    });

    this.elements = [...this.querySelectorAll('a, button, [tabindex]')];
    this.activeElement = this.dataset.preSelected ? this.querySelector(this.dataset.preSelected) : this.elements[0];
  }

  moveFocusLeft() {
    if (this.elements[0] === this.activeElement) return;
    let newIndex = this.elements.indexOf(this.activeElement) - 1;
    this.elements[newIndex].click();
    this.elements[newIndex].focus();
    this.activeElement = this.elements[newIndex];
  }

  moveFocusRight() {
    if (this.elements[this.elements.length - 1] === this.activeElement) return;
    let newIndex = this.elements.indexOf(this.activeElement) + 1;
    this.elements[newIndex].click();
    this.elements[newIndex].focus();
    this.activeElement = this.elements[newIndex];
  }

  moveFocusStart() {
    let newIndex = 0;
    this.elements[newIndex].click();
    this.elements[newIndex].focus();
    this.activeElement = this.elements[newIndex];
  }

  moveFocusEnd() {
    let newIndex = this.elements.length - 1;
    this.elements[newIndex].click();
    this.elements[newIndex].focus();
    this.activeElement = this.elements[newIndex];
  }

  getFocusableElements() {
    const focusableSelectors = [
      'a[href]', // Links with href
      'area[href]', // Area elements with href
      'input:not([disabled])', // Enabled input elements
      'select:not([disabled])', // Enabled select elements
      'textarea:not([disabled])', // Enabled textarea elements
      'button:not([disabled])', // Enabled button elements
      'iframe', // iframe elements
      'object', // object elements
      'embed', // embed elements
      '[contenteditable]', // Elements with contenteditable attribute
      '[tabindex]:not([tabindex="-1"])', // Elements with tabindex that is not -1
    ];

    const focusableElements = document.querySelectorAll(focusableSelectors.join(','));
    return Array.from(focusableElements).filter((el) => el.offsetParent !== null);
  }

  moveFocusOutPrevious() {
    const focusableArray = this.getFocusableElements();
    const currentIndex = focusableArray.indexOf(this.elements[0]);
    if (currentIndex > -1) {
      focusableArray[currentIndex - 1].focus();
    }
  }

  moveFocusOutNext() {
    if (this.tabOutTarget) {
      document.querySelector(this.tabOutTarget)?.focus();
    } else {
      const focusableArray = this.getFocusableElements();
      const currentIndex = focusableArray.indexOf(this.elements[this.elements.length - 1]);
      if (currentIndex > -1) {
        focusableArray[currentIndex + 1].focus();
      }
    }
  }
}

customElements.define('a11y-focus', A11yFocus);
